export function lessonEntitiesSelector(state) {
  return state.entities.lessons
}
